module.exports = __webpack_public_path__ + "fonts/poppins-extrabold-webfont.5f53abb9.woff";